import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errorMessage } from "../lib/api";
import { AuthLayout } from "./Login";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      toast.success(data.message);
      navigate("/login");
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Choose a new password">
      {!token ? (
        <p className="text-sm text-rose-700" data-testid="reset-missing-token">This reset link is missing its token. <Link to="/forgot-password" className="underline">Request a new one</Link>.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-password-form">
          <div className="space-y-1.5"><Label>New password</Label><Input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" className="h-11" /></div>
          <div className="space-y-1.5"><Label>Confirm password</Label><Input type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm-input" className="h-11" /></div>
          <Button type="submit" disabled={busy} className="w-full h-11 bg-slate-900 hover:bg-slate-800" data-testid="reset-submit-button">{busy ? "Updating…" : "Update password"}</Button>
        </form>
      )}
    </AuthLayout>
  );
}
